module.exports = __webpack_public_path__ + "static/images/active-bg.9f3ae81.png";